export enum TaxPaymentMethod {
    CASH_PAYMENT = 'A', // A - Cash payment
    DEFERRED_OR_POSTPONED_PAYMENT = 'E', // E - Deferred or postponed payment
    PAYMENT_THROUGH_POST_OFFICE = 'J', // J - Payment through post office administration (postal consignments) or other public sector
    SECURITIES = 'M', // M - Securities
}

export const taxPaymentMethodLabels = [
    { id: TaxPaymentMethod.CASH_PAYMENT, value: 'Cash payment' },
    { id: TaxPaymentMethod.DEFERRED_OR_POSTPONED_PAYMENT, value: 'Deferred or postponed payment' },
    {
        id: TaxPaymentMethod.PAYMENT_THROUGH_POST_OFFICE,
        value: 'Payment through post office administration (postal consignments) or other public sector',
    },
    { id: TaxPaymentMethod.SECURITIES, value: 'Securities' },
] as const;

export const getTaxPaymentMethodLabel = (method?: string): string | undefined => {
    if (!method) return undefined;
    return taxPaymentMethodLabels.find((item) => item.id === method)?.value;
};
